import Template from "../../Components/Authentication/Template";
import loginImg from "../../assets/utils/login.png";

function Login({ setIsLoggedIn }) {
  return (
    <Template
      title="Welcome Back"
      description1="Join OpportunityNexus and unlock your path to success"
      description2="Education to future-proof your career."
      image={loginImg}
      formType="login"
      setIsLoggedIn={setIsLoggedIn}
    />
  );
}

export default Login;
